export type InvoiceSubject = 1 | 2 | 3 | 4

export const INVOICE_SUBJECTS: Array<{
  id: InvoiceSubject
  title: string
  subtitle: string
  icon: string
  tone: string
}> = [
  {
    id: 1,
    title: 'اصلی',
    subtitle: 'اولین صورتحساب برای معامله',
    icon: 'la-file-invoice',
    tone: 'primary',
  },
  {
    id: 2,
    title: 'اصلاحی',
    subtitle: 'اصلاح اطلاعات صورتحساب مرجع',
    icon: 'la-pen',
    tone: 'warning',
  },
  {
    id: 3,
    title: 'ابطالی',
    subtitle: 'ابطال کامل صورتحساب مرجع',
    icon: 'la-ban',
    tone: 'danger',
  },
  {
    id: 4,
    title: 'برگشت از فروش',
    subtitle: 'ثبت مانده پس از برگشت کالا یا خدمت',
    icon: 'la-undo-alt',
    tone: 'info',
  },
]

export const normalizeReferenceTaxId = (value: string) =>
  (value || '')
    .replace(/\s/g, '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()
    .slice(0, 22)

export const isValidReferenceTaxId = (value: string) => /^[A-Z0-9]{22}$/.test(value || '')

export const getReferenceFiscalId = (referenceTaxId: string) => {
  const normalized = normalizeReferenceTaxId(referenceTaxId)
  return isValidReferenceTaxId(normalized) ? normalized.slice(0, 6) : ''
}

export const getFiscalMemoryUniqueId = (memory: {taxid?: string; uniqueTaxId?: string}) =>
  (memory.uniqueTaxId || memory.taxid || '').trim().toUpperCase()

export const isSalesReturnInvoiceSubject = (subject: InvoiceSubject) => subject === 4

export const isReferralInvoiceSubject = (subject: InvoiceSubject) => subject !== 1

export const normalizeInvoiceSubject = (subject: unknown): InvoiceSubject =>
  subject === 2 || subject === 3 || subject === 4 ? subject : 1

export const resolveEffectiveInvoiceSubject = (
  action: number | undefined,
  selectedSubject: InvoiceSubject
): InvoiceSubject =>
  [2, 3, 4].includes(action || 0) ? (action as InvoiceSubject) : selectedSubject

export const getInvoiceSubjectRules = (subject: InvoiceSubject): string[] => {
  switch (subject) {
    case 2:
      return [
        'نوع و الگوی صورتحساب اصلاحی باید با صورتحساب مرجع یکسان باشد.',
        'اطلاعات کامل صورتحساب مرجع را وارد و فقط موارد مجاز را اصلاح کنید؛ صورتحساب مرجع پس از پذیرش اصلاحیه، ابطال می‌شود.',
        'برای تغییر تاریخ صدور، شناسه کالا/خدمت یا اطلاعات هویتی اصلی خریدار، از صورتحساب ابطالی استفاده کنید.',
      ]
    case 3:
      return [
        'ابطال برای عدم وقوع معامله یا تغییر اطلاعات پایه‌ای است که با صورتحساب اصلاحی قابل تغییر نیست.',
        'در این فرم فقط شماره صورتحساب ابطالی، شناسه مالیاتی مرجع، تاریخ صورتحساب و توضیحات ثبت می‌شود.',
      ]
    case 4:
      return [
        'نوع و الگوی صورتحساب برگشت از فروش باید با صورتحساب مرجع یکسان باشد.',
        'اقلام این صورتحساب باید مانده کالا یا خدمت پس از برگشت را نشان دهند؛ خروجی کارپوشه شامل جزئیات اقلام نیست.',
        'اگر همه اقلام و مقادیر برگشت داده شده‌اند، به‌جای برگشت از فروش از صورتحساب ابطالی استفاده کنید.',
      ]
    default:
      return ['صورتحساب اصلی، اولین صورتحساب الکترونیکی صادرشده برای یک معامله است.']
  }
}
